/* eslint-disable */
export default [
  {
    path: "/dashboard/home",
    name: "home",
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/Home.vue"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumbType: "date",
      breadcrumb: [
        {
          text: "UI"
        },
        {
          text: "Dashboard",
          active: true
        }
      ]
    }
  },
  // {
  //   path: "/dashboard/campaign",
  //   name: "campaign",
  //   component: () => import("@/views/dashboard/CampaignDash.vue"),
  //   meta: {
  //     // pageTitle: 'Dashboard',
  //     // breadcrumbType: 'date',
  //     breadcrumb: [
  //       {
  //         text: "Dashboard"
  //       },
  //       {
  //         text: "Campaign",
  //         active: true
  //       }
  //     ]
  //   }
  // },
  {
    path: "/dashboard/blank",
    name: "home-blank",
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/HomeBlank.vue"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "UI"
        },
        {
          text: "Dashboard",
          active: true
        }
      ]
    }
  },
  {
    path: "/crm/tool/kiemtra",
    name: "checkin",
    component: () => import(/* webpackChunkName: "tool" */ "@/views/tool/CheckTB.vue"),
    meta: {
      pageTitle: "Kiểm tra thuê bao",
      resource: "Auth",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Tool",
          active: true
        }
      ]
    }
  },
  {
    path: "/admin/master-data",
    name: "master-data",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Dữ liệu danh mục",
      breadcrumb: [
        {
          text: "Admin"
        },
        {
          text: "Master Data",
          active: true
        }
      ]
    }
  },
  /*--------------App---------------*/
  // {
  //     path: '/apps/calendar',
  //     name: 'apps-calendar',
  //     component: () => import('@/views/apps/calendar/Calendar.vue'),
  // },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  // {
  //     path: '/apps/todo',
  //     name: 'apps-todo',
  //     component: () => import('@/views/apps/todo/Todo.vue'),
  //     meta: {
  //         contentRenderer: 'sidebar-left',
  //         contentClass: 'todo-application',
  //     },
  // },
  // {
  //     path: '/apps/todo/:filter',
  //     name: 'apps-todo-filter',
  //     component: () => import('@/views/apps/todo/Todo.vue'),
  //     meta: {
  //         contentRenderer: 'sidebar-left',
  //         contentClass: 'todo-application',
  //         navActiveLink: 'apps-todo',
  //     },
  //     beforeEnter(to, _, next) {
  //         if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
  //         else next({ name: 'error-404' })
  //     },
  // },
  // {
  //     path: '/apps/todo/tag/:tag',
  //     name: 'apps-todo-tag',
  //     component: () => import('@/views/apps/todo/Todo.vue'),
  //     meta: {
  //         contentRenderer: 'sidebar-left',
  //         contentClass: 'todo-application',
  //         navActiveLink: 'apps-todo',
  //     },
  //     beforeEnter(to, _, next) {
  //         if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
  //         else next({ name: 'error-404' })
  //     },
  // },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*

  /*--------------App---------------*/

  {
    path: "/error-404",
    name: "error-404",
    component: () => import(/* webpackChunkName: "others" */ "@/views/others/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read"
    }
  },
  {
    path: "/auth/login",
    name: "auth-login",
    component: () => import(/* webpackChunkName: "others" */ "@/views/auth/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true
    }
  },

  {
    path: "/others/coming-soon",
    name: "misc-coming-soon",
    component: () => import(/* webpackChunkName: "others" */ "@/views/others/ComingSoon.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/others/under-maintenance",
    name: "misc-under-maintenance",
    component: () => import(/* webpackChunkName: "others" */ "@/views/others/UnderMaintenance.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/profile",
    name: "pages-profile",
    component: () => import(/* webpackChunkName: "others" */ "@/views/auth/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [
        {
          text: "Pages"
        },
        {
          text: "Profile",
          active: true
        }
      ]
    }
  },
  {
    path: "/faq",
    name: "pages-faq",
    component: () => import(/* webpackChunkName: "others" */ "@/views/auth/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [
        {
          text: "Pages"
        },
        {
          text: "Profile",
          active: true
        }
      ]
    }
  },
  // *--------------------------------------------------------------------
  {
    path: "/admin/group-mgmt",
    name: "group-mgmt",
    component: () => import(/* webpackChunkName: "others" */ "@/views/admin/Group.vue"),
    meta: {
      pageTitle: "Quản lý quyền",
      breadcrumb: [
        {
          text: "Admin"
        },
        {
          text: "Group Management",
          active: true
        }
      ]
    }
  },
  {
    path: "/admin/user-mgmt",
    name: "user-mgmt",
    component: () => import(/* webpackChunkName: "others" */ "@/views/admin/User.vue"),
    meta: {
      pageTitle: "Quản lý người dùng",
      breadcrumb: [
        {
          text: "Admin"
        },
        {
          text: "User Management",
          active: true
        }
      ]
    }
  },
  {
    path: "/b2c/orders",
    name: "don-hang",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/Orders.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/ordersV3",
    name: "don-hangV3",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/OrdersV3.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/order_process",
    name: "order_process",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/order/OrderProcess.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/demo_orders",
    name: "demo-don-hang",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/DemoOrders.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/Pjico",
    name: "BH-Pjico",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/Pjico.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/doi-sim",
    name: "doi-sim",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/DoiSim.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/b2c/usim-management",
    name: "usim-management",
    component: () => import(/* webpackChunkName: "b2c" */ "@/views/b2c/usimManagement.vue"),
    meta: {
      /*pageTitle: 'Quản lý đơn hàng',
            breadcrumb: [
                {
                    text: 'B2C',
                },

            ],*/
    }
  },
  {
    path: "/dashboard/DiscountCodReferralCode",
    name: "discount_code-referral_code",
    component: () => import(/* webpackChunkName: "DiscountCode" */ "@/views/dashboard/DiscountCodeReferralCode.vue")
    // meta: {
    //     breadcrumb: [
    //         {
    //             text: 'Dashboard',
    //         },
    //         {
    //             text: 'DiscountCodeReferralCode',
    //             active: true,
    //         },
    //     ],
    // },
  },
  {
    path: "/general-setting/DiscountCode",
    name: "DiscountCode",
    component: () => import(/* webpackChunkName: "DiscountCode" */ "@/views/general-setting/DiscountCode.vue")
    // meta: {
    //     breadcrumb: [
    //         {
    //             text: 'general-setting',
    //         },
    //         {
    //             text: 'DiscountCode',
    //             active: true,
    //         },
    //     ],
    // },
  },
  {
    path: "/general-setting/ReferralCode",
    name: "ReferralCode",
    component: () => import(/* webpackChunkName: "DiscountCode" */ "@/views/general-setting/ReferralCode.vue")
    // meta: {
    //     breadcrumb: [
    //         {
    //             text: 'general-setting',
    //         },
    //         {
    //             text: 'DiscountCode',
    //             active: true,
    //         },
    //     ],
    // },
  },
  // {
  //     path: '/general-setting/ReferralCodeMGM',
  //     name: 'ReferralCodeMGM',
  //     component: () => import('@/views/general-setting/ReferralCodeMGM.vue'),
  //     // meta: {
  //     //     breadcrumb: [
  //     //         {
  //     //             text: 'general-setting',
  //     //         },
  //     //         {
  //     //             text: 'DiscountCode',
  //     //             active: true,
  //     //         },
  //     //     ],
  //     // },
  // },
  {
    path: "/kho-so",
    name: "sim-so",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Kho số",
      type: "Inventory",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/tag",
    name: "tag",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Tag",
      type: "Tag",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/ESIM",
    name: "ESIM",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Quản lý eSIM",
      type: "ESIM",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/loai-so",
    name: "loai-so",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Loại số",
      type: "SimConfigGroup",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/danh-muc-so",
    name: "danh-muc-so",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Danh mục số",
      type: "SimCategory",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/giu-so",
    name: "giu-so",
    component: () => import(/* webpackChunkName: "SIM" */ "@/views/b2c/Keep.vue"),
    meta: {
      pageTitle: "Giữ số",
      type: "SimConfigGroup",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  /*{
        path: '/B2C-Campaign',
        name: 'B2C-Campaign',
        component: () => import('@/views/admin/MasterData.vue'),
        meta: {
            pageTitle: 'Quản lý Campaign bán hàng',
            type: 'B2C_Campaign',
            breadcrumb: [
                {
                    text: 'B2C',
                },
            ],
        },
    },*/
  {
    path: "/B2C-Campaign-Config",
    name: "B2C-Campaign-Config",
    component: () => import(/* webpackChunkName: "Campaign" */ "@/views/camp/CampaignMgmt.vue"),
    meta: {
      pageTitle: "Quản lý Campaign",
      type: "B2C_Campaign_Config",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/Partner-Campaign",
    name: "Partner-Campaign",
    component: () => import(/* webpackChunkName: "Campaign" */ "@/views/camp/PartnerCampaignMgmt.vue"),
    meta: {
      pageTitle: "Quản lý Campaign dành cho đối tác",
      type: "B2C_Campaign",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/SCHEDULER",
    name: "SCHEDULER",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Quản lý tiến trình",
      type: "SCHEDULER",
      breadcrumb: [
        {
          text: "Admin"
        }
      ]
    }
  },
  {
    path: "/SCHEDULE_LOGS",
    name: "SCHEDULE_LOGS",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/admin/MasterData.vue"),
    meta: {
      pageTitle: "Log tiến trình",
      type: "SCHEDULE_LOGS",
      breadcrumb: [
        {
          text: "Admin"
        }
      ]
    }
  },
  {
    path: "/bao-cao-don-hang",
    name: "bc-don-hang",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/Summary.vue"),
    meta: {
      pageTitle: "Báo cáo đơn hàng",
      report: "BC-Ban-Hang",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-sim-phong-thuy",
    name: "bc-sim-phong-thuy",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/SimPhongThuy.vue"),
    meta: {
      pageTitle: "Báo cáo sim phong thủy",
      report: "BC-SimPhongThuy",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bc-tima",
    name: "bc-tima",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/Tima.vue"),
    meta: {
      pageTitle: "Báo cáo Tima",
      report: "BC_Tima",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-sim-may-man",
    name: "bc-sim-may-man",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/SimMayMan.vue"),
    meta: {
      pageTitle: "Báo cáo quay số may mắn",
      report: "BC-QuaySoMM",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-tra-hang",
    name: "bc-tra-hang",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CTraHang.vue"),
    meta: {
      pageTitle: "Báo cáo trả hàng",
      report: "BC-Tra-Hang",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-ux",
    name: "bc-ux",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CUX.vue"),
    meta: {
      pageTitle: "Báo cáo đánh giá trải nghiệm",
      report: "BC_UX",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-accesstrade",
    name: "bc-accesstrade",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CAccesstrade.vue"),
    meta: {
      pageTitle: "Báo cáo đối soát Accesstrade",
      report: "BC_Accesstrade",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-purchase-journey",
    name: "bc-purchase-journey",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CPurchaseJourney.vue"),
    meta: {
      pageTitle: "Báo cáo hành trình mua hàng",
      report: "BC-HanhTrinh-MuaHang",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-promotion",
    name: "bc-promotion",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CPromotion.vue"),
    meta: {
      pageTitle: "Báo cáo đối soát promotion",
      report: "BC_Voucher_Pro",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-voucher",
    name: "bc-voucher",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CVoucher.vue"),
    meta: {
      pageTitle: "Báo cáo đối soát voucher",
      report: "BaoCaoVoucher",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-affiliate",
    name: "bc-affiliate",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CAffiliate.vue"),
    meta: {
      pageTitle: "Báo cáo Affiliate",
      report: "BC_Affiliate",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-outbound-sumary",
    name: "bao-cao-outbound-sumary",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2COutboundSumary.vue"),
    meta: {
      pageTitle: "Báo cáo tổng hợp outbound",
      report: "BC_Outbound_Sumary",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-outbound-detail",
    name: "bao-cao-outbound-detail",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2COutboundDetail.vue"),
    meta: {
      pageTitle: "Báo cáo chi tiết outbound",
      report: "BC_Outbound_Detail",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-callboot",
    name: "bao-cao-callboot",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CCallboot.vue"),
    meta: {
      pageTitle: "Báo cáo callboot",
      report: "BC_Callboot",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-sale-order-detail",
    name: "bao-cao-sale-order-detail",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CSalesOrderDetails.vue"),
    meta: {
      pageTitle: "Báo cáo chi tiết đơn hàng bán thiết bị",
      report: "BC_SalesOrderDetails",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-summary",
    name: "bao-cao-summary",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CSummaryReport.vue"),
    meta: {}
  },
  {
    path: "/common/:type",
    name: "common",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/admin/Common.vue")
  },
  {
    path: "/client/:type",
    name: "client",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/admin/Client.vue")
  },
  {
    path: "/bao-cao-keyword",
    name: "bc-keyword",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CKeyword.vue"),
    meta: {
      pageTitle: "Báo cáo từ khoá tìm kiếm",
      report: "BC_KEYWORD",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bao-cao-journey",
    name: "b2c-journey",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CJourney.vue"),
    meta: {
      pageTitle: "Báo cáo hành trình khách hàng",
      report: "BC_JOURNEY",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bc-ct-don-hang",
    name: "bc-ct-don-hang",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/Summary2.vue"),
    meta: {
      pageTitle: "Báo cáo chi tiết đơn hàng",
      report: "BC-Ban-Hang2",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/campaign-report",
    name: "campaign-report",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/Campaign.vue"),
    meta: {
      pageTitle: "Báo cáo chiến dịch",
      report: "Campaign-Report",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/telesale-report",
    name: "telesale-report",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/TelesaleReport.vue"),
    meta: {
      pageTitle: "Báo cáo Telesale",
      report: "BC_TELESALE",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/usim-report",
    name: "usim-report",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/Usim.vue"),
    meta: {
      pageTitle: "Báo cáo USIM",
      report: "Usim-Report",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bc-khaosat-ces",
    name: "bc-khaosat-ces",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/BurchaseSurvey.vue"),
    meta: {
      pageTitle: "Báo cáo kháo sát CES",
      report: "BC_SurveyCES",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bc-vietlot",
    name: "bc-vietlot",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/B2CVietlot.vue"),
    meta: {
      pageTitle: "Báo cáo Vietlott",
      report: "BC_Vietlott",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/bc-abtrip",
    name: "bc-abtrip",
    beforeEnter(to, from, next) {
      window.location.href = "https://abtrip.vn/manage";
    }
  },
  {
    path: "/bc-doi-sim",
    name: "bc-doi-sim",
    component: () => import(/* webpackChunkName: "bc" */ "@/views/report/ReportForSim.vue"),
    meta: {
      pageTitle: "Báo cáo đối SIM/ESIM ",
      report: "BC_DoiSim",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/news/category",
    name: "news-category",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/news/Categories.vue"),
    meta: {
      pageTitle: "Cổng thông tin iTel",
      report: "news-Category-Report",
      breadcrumb: [
        {
          text: "Danh mục"
        }
      ]
    }
  },
  {
    path: "/news/category/topics",
    name: "news-category-topics",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/news/Topics.vue"),
    meta: {
      pageTitle: "Danh sách chủ đề",
      report: "news-Category-Topics",
      breadcrumb: [
        {
          text: "Danh mục",
          to: "/news/category"
        },
        {
          text: "Chủ đề",
          active: true
        }
      ]
    }
  },
  {
    path: "/news/category/topics/:Slug",
    name: "news-category-topics-news",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/news/NewDetail.vue"),
    meta: {
      pageTitle: "Danh sách chủ đề",
      report: "news-Category-Topics",
      breadcrumb: [
        {
          text: "Danh mục",
          to: "/news/category"
        },
        {
          text: "Chủ đề",
          to: "/news/category/topics",
          active: true
        },
        {
          text: "Bài viết",
          active: true
        }
      ]
    }
  },
  {
    path: "/admin-topics",
    name: "admin-topics",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/news/AdminTopic.vue"),
    meta: {
      pageTitle: "Quản lý danh sách chủ đề",
      type: "admin-topics",
      breadcrumb: [
        {
          text: "news"
        }
      ]
    }
  },
  {
    path: "/admin-news",
    name: "admin-news",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/news/AdminNews.vue"),
    meta: {
      pageTitle: "Quản lý danh sách bài viết",
      type: "admin-news",
      breadcrumb: [
        {
          text: "news"
        }
      ]
    }
  },
  {
    path: "/account-setting",
    name: "pages-account-setting",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/account-setting/AccountSetting.vue"),
    meta: {
      pageTitle: "Account Settings",
      breadcrumb: [
        {
          text: "Pages"
        },
        {
          text: "Account Settings",
          active: true
        }
      ]
    }
  },
  {
    path: "/sms-gapit",
    name: "sms-gapit",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/tool/CheckSMSGAPIT.vue")
    // meta: {
    //     pageTitle: 'Tra cứu sms GAPIT',
    //     breadcrumb: [
    //         {
    //             text: 'Pages',
    //         },
    //         {
    //             text: 'Account Settings',
    //             active: true,
    //         },
    //     ],
    // },
  },
  {
    path: "/kich-hoat-goi-cho",
    name: "PackActivation",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/tool/PackActivation.vue")
    // meta: {
    //     pageTitle: 'Tra cứu sms GAPIT',
    //     breadcrumb: [
    //         {
    //             text: 'Pages',
    //         },
    //         {
    //             text: 'Account Settings',
    //             active: true,
    //         },
    //     ],
    // },
  },
  {
    path: "/call-ob/delivered-order",
    name: "delivered-order",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/callOB/deliveredOrder.vue"),
    meta: {
      // pageTitle: 'Đơn hàng',
      // breadcrumb: [
      //     {
      //         text: 'Call OB',
      //     },
      //     {
      //         text: 'Đơn hàng',
      //         active: true,
      //     },
      // ],
    }
  },
  {
    path: "/call-ob/campaign",
    name: "ob-campaign",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/callOB/OBCamp.vue"),
    meta: {
      // pageTitle: 'Đơn hàng',
      // breadcrumb: [
      //     {
      //         text: 'Call OB',
      //     },
      //     {
      //         text: 'Đơn hàng',
      //         active: true,
      //     },
      // ],
    }
  },
  {
    path: "/view360/telesale-order",
    name: "telesale-order",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/view360/telesaleOrder.vue"),
    meta: {
      // pageTitle: 'Telesale',
      // breadcrumb: [
      //     {
      //         text: 'View 360',
      //     },
      //     {
      //         text: 'Telesale',
      //         active: true,
      //     },
      // ],
    }
  },
  // {
  //   path: "/video-call",
  //   name: "videoCall",
  //   component: () => import("@/views/videoCall/VideoCall.vue"),
  //   meta: {
  //     pageTitle: "Video Call",
  //     breadcrumb: [
  //       {
  //         text: "Video Call"
  //       }
  //     ]
  //   }
  // },
  {
    path: "/congtt-admin-danh-muc",
    name: "congtt-admin-danh-muc",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminCategories.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Khai báo danh mục"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-chinh-sach",
    name: "congtt-admin-chinh-sach",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminPolicy.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-chinh-sach',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý chính sách"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-goi-cuoc",
    name: "congtt-admin-goi-cuoc",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminPackData.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-goi-cuoc',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý gói cước"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-quy-trinh-quy-dinh",
    name: "congtt-admin-quy-trinh-quy-dinh",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminProcess.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-quy-trinh-quy-dinh',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý quy trình & quy định"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-chuong-trinh-khuyen-mai",
    name: "congtt-admin-chuong-trinh-khuyen-mai",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminPomotion.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-chuong-trinh-khuyen-mai',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý chương trình khuyến mại"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-huong-dan-su-dung",
    name: "congtt-admin-huong-dan-su-dung",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminHelp.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-huong-dan-su-dung',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý hướng dẫn sử dụng"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-q-a",
    name: "congtt-admin-q-a",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminQA.vue"),
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-q-a',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin ",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý Q&A"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-phong-ban",
    name: "congtt-admin-phong-ban",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminDepartment.vue"),

    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-admin-phong-ban',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Khai báo phòng ban"
        }
      ]
    }
  },
  {
    path: "/congtt-list-policies/:topicId",
    name: "congtt-list-policies",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/NewsList.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-list-news',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Chính sách sản phẩm"
        }
      ]
    }
  },
  {
    path: "/congtt-list-helps/:topicId",
    name: "congtt-list-helps",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/NewsList.vue"),
    props: true,
    meta: {
      // type: 'congtt-list-news',
      pageTitle: "Quản trị cổng thông tin",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin iTel",
          to: "congtt-admin-menu"
        },
        {
          text: "Hướng dẫn"
        }
      ]
    }
  },
  {
    path: "/congtt-list-promotions/:topicId",
    name: "congtt-list-promotions",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/NewsList.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-list-news',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Chương trình khuyến mãi"
        }
      ]
    }
  },
  {
    path: "/congtt-list-process/:topicId",
    name: "congtt-list-process",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/NewsList.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-list-news",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quy trình quy định"
        }
      ]
    }
  },
  {
    path: "/congtt-pack-data-list/:topicId",
    name: "congtt-pack-data-list",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/PackDataList.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-pack-data-list",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Sản phẩm gói cước"
        }
      ]
    }
  },
  {
    path: "/congtt-qa-list/:topicId",
    name: "congtt-qa-list",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/QAList.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      // type: 'congtt-qa-list',
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Q&A"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-email",
    name: "congtt-admin-email",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminEmailConfig.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-admin-email",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Cấu hình email"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-feedback",
    name: "congtt-admin-feedback",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminFeedback.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-admin-feedback",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Quản lý thông tin phản hồi"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-sms",
    name: "congtt-admin-sms",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminSMS.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-admin-sms",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin",
          to: "congtt-admin-menu"
        },
        {
          text: "Tra cứu thông tin gửi sms"
        }
      ]
    }
  },
  {
    path: "/congtt-hot-new",
    name: "congtt-hot-new",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/HotNews.vue"),
    props: true,
    meta: {
      // pageTitle: 'Danh mục',
      type: "congtt-hot-new",
      breadcrumb: [
        {
          text: "Tra cứu Hot News"
        }
      ]
    }
  },
  {
    path: "/congtt-categories",
    name: "congtt-categories",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/Categories.vue"),
    props: true,
    meta: {
      // type: 'congtt-admin-menu',
      pageTitle: "CSKH ITEL",
      breadcrumb: [
        {
          text: "Cổng thông tin iTel"
        }
      ]
    }
  },
  {
    path: "/congtt-categories-new",
    name: "congtt-categories-new",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/CategoriesNew.vue"),
    props: true,
    meta: {
      // type: 'congtt-admin-menu',
      // pageTitle: 'CSKH ITEL',
      // breadcrumb: [
      //     {
      //         text: 'Cổng thông tin iTel',
      //     },
      // ],
    }
  },
  {
    path: "/congtt-admin-menu",
    name: "congtt-admin-menu",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminMenu.vue"),
    props: true,
    meta: {
      pageTitle: "Quản trị cổng thông tin",
      type: "congtt-admin-menu",
      breadcrumb: [
        {
          text: "Quản trị cổng thông tin"
        }
      ]
    }
  },
  {
    path: "/congtt-admin-menu-new",
    name: "congtt-admin-menu-new",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminMenuNew.vue"),
    props: true,
    meta: {
      // pageTitle: 'Quản trị cổng thông tin',
      type: "congtt-admin-menu-new"
      // breadcrumb: [
      //     {
      //         // text: 'Quản trị cổng thông tin',
      //     },
      // ],
    }
  },
  {
    path: "/congtt-admin-vinh-danh-nvcskh",
    name: "congtt-admin-vinh-danh-nvcskh",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminMenuHonors.vue"),
    props: true,
    meta: {
      type: "congtt-admin-vinh-danh-nvcskh"
    }
  },
  {
    path: "/congtt-admin-thong-bao-nvcskh",
    name: "congtt-admin-thong-bao-nvcskh",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminMenuNotice.vue"),
    props: true,
    meta: {
      type: "congtt-admin-thong-bao-nvcskh"
    }
  },
  {
    path: "/congtt-admin-loai-thong-bao",
    name: "congtt-admin-loai-thong-bao",
    component: () => import(/* webpackChunkName: "CSKH" */ "@/views/portal/admin/AdminTypeNotice.vue"),
    props: true,
    meta: {
      type: "congtt-admin-loai-thong-bao"
    }
  },
  {
    path: "/blacklist",
    name: "blacklist",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/blacklist/Blacklist.vue"),
    meta: {
      pageTitle: "Danh sách thuê bao Blacklist",
      breadcrumb: []
    }
  },
  {
    path: "/noti-request/home",
    name: "noti-request",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/requestForm/requestForm.vue"),
    meta: {
      pageTitle: "Phiếu yêu cầu",
      breadcrumb: []
    }
  },
  {
    path: "/noti-request/create",
    name: "noti-create-request",
    component: () =>
      import(/* webpackChunkName: "request" */ "@/views/requestForm/components/create/createRequestForm.vue"),
    meta: {
      pageTitle: "Tạo phiếu yêu cầu",
      breadcrumb: []
    }
  },
  {
    path: "/noti-request/edit/:id",
    name: "noti-edit-request",
    component: () =>
      import(/* webpackChunkName: "request" */ "@/views/requestForm/components/editModelForm/editModelForm.vue"),
    meta: {
      pageTitle: "Chỉnh sửa phiếu yêu cầu",
      breadcrumb: []
    }
  },
  {
    path: "/noti-request/view/:id",
    name: "noti-view-request",
    component: () =>
      import(/* webpackChunkName: "request" */ "@/views/requestForm/components/viewDetail/viewDetail.vue"),
    meta: {
      pageTitle: "Chi tiết phiếu yêu cầu",
      breadcrumb: []
    }
  },
  {
    path: "/general-noti-request",
    name: "general-noti-request",
    component: () =>
      import(/* webpackChunkName: "request" */ "@/views/generalRequestForm/generalRequestForm.vue"),
    meta: {
      pageTitle: "Phiếu yêu cầu tổng hợp",
      breadcrumb: []
    }
  },
  {
    path: "/general-noti-request/view/:id",
    name: "general-noti-request",
    component: () =>
      import(/* webpackChunkName: "request" */
          "@/views/generalRequestForm/components/detailGeneralRequestForm/detailGeneralRequestForm.vue"
      ),
    meta: {
      pageTitle: "Chi tiết phiếu yêu cầu tổng hợp",
      breadcrumb: []
    }
  },
  {
    path: "/general-noti-request/calendar",
    name: "general-noti-request-calendar",
    component: () =>
      import(/* webpackChunkName: "request" */ "@/views/requestFormCalendar/requestFormCalendar.vue"),
    meta: {
      pageTitle: "Tổng hợp lịch gửi SMS/Thông báo phiếu yêu cầu",
      breadcrumb: []
    }
  },
  {
    path: "/vpbank/home",
    name: "vpbank/home",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/vpbank/vpbank.vue"),
    meta: {}
  },
  {
    path: "/topup-vpbank/home",
    name: "topup-vpbank/home",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/topupVpbank/topupVpbank.vue"),
    meta: {}
  },
  {
    path: "/aff/vpbank",
    name: "aff_vpbank",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/aff/VPBank.vue"),
    meta: {}
  },
  {
    path: "/tool/provision-package",
    name: "provision-package",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/tool/ProvisionPackage.vue"),
    meta: {}
  },
  {
    path: "/change-device-verify",
    name: "change-device-verify",
    component: () => import(/* webpackChunkName: "tool" */ "@/views/tool/ChangeDeviceVerify.vue"),
    meta: {
      pageTitle: "Xác thực đổi thiết bị",
      resource: "Auth",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Xác thực đổi thiết bị",
          active: true
        }
      ]
    }
  },
  {
    path: "/order/ecommerce-order",
    name: "ecommerce-order",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/orders/EcommerceOrder.vue"),
    meta: {}
  },
  // {
  //   path: "/videoCall/DKTT",
  //   name: "VideoCallDKTT",
  //   component: () => import("@/views/videoCallDKTT/VideoCallDKTT.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: "Đăng ký thông tin"
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: "/videoCall/CNTT",
  //   name: "VideoCallCNTT",
  //   component: () => import("@/views/videoCallDKTT/VideoCallCNTT.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: "Cập nhật thông tin"
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: "/videoCall/QuanLyDTV",
  //   name: "QuanLyDTV",
  //   component: () => import("@/views/videoCallDKTT/QuanLyDTV.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: "Quản lý ĐTV"
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: "/videoCall/DSTB",
  //   name: "VideoCallDSTB",
  //   component: () => import("@/views/videoCallDKTT/VideoCallDSTB.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: "Đăng ký thông tin"
  //       }
  //     ]
  //   }
  // },
  {
    path: "/bao-cao-goi-km",
    name: "bao-cao-goi-km",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/report/ProvisionPackageReport.vue"),
    meta: {
      pageTitle: "Báo cáo đăng ký gói khuyến mại",
      report: "BC_ProvisionPackageReport",
      breadcrumb: [
        {
          text: "B2C"
        }
      ]
    }
  },
  {
    path: "/in-lai-phieu",
    name: "in-lai-phieu",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/rePrintTicket/rePrintTicket.vue"),
    meta: {
      breadcrumb: [
        {
          text: "In lại phiếu"
        }
      ]
    }
  },
  {
    path: "/otp-list",
    name: "otp-list",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/otp-register/OtpCheckList.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Danh sách OTP"
        }
      ]
    }
  },
  {
    path: "/change-signature",
    name: "change-signature",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/change-signature/ChangeSignature.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Thay đổi chữ ký"
        }
      ]
    }
  },
  {
    path: "/gencode/:code",
    name: "gencode",
    component: () => import(/* webpackChunkName: "Other" */ "@/views/gencode/index.vue"),
    meta: {
      breadcrumb: [
        {
          text: "La La La"
        }
      ]
    }
  },
];
